import React, { createContext, useState, useEffect } from 'react';
import api from '../services/api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadUserFromStorage = () => {
      const token = localStorage.getItem('token');
      const storedUser = localStorage.getItem('user');
      const storedCompany = localStorage.getItem('company');

      if (token) {
        api.defaults.headers.Authorization = `Bearer ${token}`;
        setUser(JSON.parse(storedUser));
        if (storedCompany) {
          setCompany(JSON.parse(storedCompany));
        }
      }
      setLoading(false);
    };

    loadUserFromStorage();

    const handleSessionExpired = () => {
      console.log('Sessão expirada. Fazendo logout.');
      logout();
    };

    window.addEventListener('sessionExpired', handleSessionExpired);

    return () => {
      window.removeEventListener('sessionExpired', handleSessionExpired);
    };
  }, []); // Roda apenas uma vez

  const login = async (identifier, password, rememberMe = false) => {
    try {
      const res = await api.post('/auth/login', { identifier, password, rememberMe });
      const { token, user: loggedInUser } = res.data;

      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(loggedInUser));
      
      // Armazena dados da empresa se disponíveis
      if (loggedInUser.company) {
        localStorage.setItem('company', JSON.stringify(loggedInUser.company));
        setCompany(loggedInUser.company);
      }
      
      api.defaults.headers.Authorization = `Bearer ${token}`;

      setUser(loggedInUser);
    } catch (err) {
      // Re-lança o erro original da API para que o componente que chamou a função (Login.js) possa tratá-lo.
      // Não faz logout aqui, apenas propaga o erro
      throw err; 
    }
  };

  const logout = async () => {
    try {
      // Chama o endpoint de logout para invalidar a sessão no backend.
      await api.post('/auth/logout'); 
    } catch (error) {
      console.error('Erro ao fazer logout no servidor, limpando localmente de qualquer maneira.', error);
    } finally {
      // Limpa os dados locais independentemente do sucesso da chamada à API
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('company');
      api.defaults.headers.Authorization = undefined;
      setUser(null);
      setCompany(null);
    }
  };

  return (
    <AuthContext.Provider value={{ user, setUser, company, setCompany, loading, login, logout }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};